/**
 * Polices autorisées pour la charte client : LISTE FERMÉE de familles système.
 * Aucun fichier de police téléversé, aucune URL externe, aucune @font-face : la valeur stockée est
 * une clé de cette liste, jamais une chaîne CSS libre (pas d'injection CSS).
 */
export const SAFE_FONTS = {
  calibri: { label: 'Calibri (par défaut)', stack: '"Calibri","Segoe UI",Arial,sans-serif' },
  arial: { label: 'Arial', stack: 'Arial,Helvetica,sans-serif' },
  verdana: { label: 'Verdana', stack: 'Verdana,Geneva,sans-serif' },
  tahoma: { label: 'Tahoma', stack: 'Tahoma,Geneva,sans-serif' },
  trebuchet: { label: 'Trebuchet MS', stack: '"Trebuchet MS",Helvetica,sans-serif' },
  georgia: { label: 'Georgia (serif)', stack: 'Georgia,"Times New Roman",serif' },
  times: { label: 'Times New Roman (serif)', stack: '"Times New Roman",Times,serif' },
  cambria: { label: 'Cambria (serif)', stack: 'Cambria,Georgia,serif' },
} as const;

export type SafeFontKey = keyof typeof SAFE_FONTS;

export const SAFE_FONT_KEYS = Object.keys(SAFE_FONTS) as [SafeFontKey, ...SafeFontKey[]];
export const DEFAULT_FONT_KEY: SafeFontKey = 'calibri';

export function isSafeFontKey(value: unknown): value is SafeFontKey {
  return typeof value === 'string' && Object.prototype.hasOwnProperty.call(SAFE_FONTS, value);
}

export function fontStack(key: SafeFontKey): string {
  return SAFE_FONTS[key].stack;
}
